import { MENU } from '@/types/common';
import { writable } from 'svelte/store';
import '@/config';
const { subscribe, update, set } = writable(MENU.CLIPS);
// const { subscribe, update } = writable(MENU.TEST);
const actions = {
    update: (index) => {
        update(() => MENU[index]);
    }
};
const menu = {
    subscribe,
    ...actions,
    set
};
export default menu;
